// extracted by css-extract-rspack-plugin
module.exports =  {"end":"End-czfu__end","spinner":"End-PG5X__spinner","message":"End-_jHw__message","button-container":"End-tmWx__button-container"};